import { defineMessages } from 'react-intl';

export default defineMessages({

  whatItemsAreYouClaimingFor: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.whatItemsAreYouClaimingFor',
    defaultMessage: 'What items are you claiming for?',
  },
  thisSectionRelatesToExpensesForYourCash: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.thisSectionRelatesToExpensesForYourCash',
    defaultMessage: 'This section relates to expenses for your cash, bank cards and travel documents.',
  },
  bankCardsOrTravelDocuments: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.bankCardsOrTravelDocuments',
    defaultMessage: 'Bank cards or travel documents',
  },
  cash: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.cash',
    defaultMessage: 'Cash',
  },
  expenseFor: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfExpense: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.descriptionOfExpense',
    defaultMessage: 'Description of Item',
  },
  dateOfExpenses: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  amountClaimed: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.currency',
    defaultMessage: 'Currency',
  },
  haveYouReceivedReimbursement: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received Reimbursement?',
  },
  dateReimbursementReceived: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },
  fromWhom: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.fromWhom',
    defaultMessage: 'If so, from whom?',
  },
  estimatedValue: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.estimatedValue',
    defaultMessage: 'Actual Cost',
  },
  howMuch: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.howMuch',
    defaultMessage: 'How much?',
  },
  costOfReplacement: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.costOfReplacement',
    defaultMessage: 'Cost of Replacement',
  },
  originalCost: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.originalCost',
    defaultMessage: 'Original Cost',
  },
  dateOfPurchase: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.dateOfPurchase',
    defaultMessage: 'Date Of Purchase',
  },
  depreciationType: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.depreciationType',
    defaultMessage: 'Depreciation Type',
  },
  isRequired: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  yes: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.no',
    defaultMessage: 'No',
  },
  areYouClaimingForASpecifiedItem: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.areYouClaimingForASpecifiedItem',
    defaultMessage: 'Are you claiming for a Specified Item?',
  },
  pleaseSelectTheItemYouAreClaimingFor: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.pleaseSelectTheItemYouAreClaimingFor',
    defaultMessage: 'please Select The Item You Are Claiming For:',
  },
  itemType: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.itemType',
    defaultMessage: 'Item Type',
  },
  descriptionOfValuables: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.descriptionOfValuables',
    defaultMessage: 'Description Of Valuables',
  },
  amountAUD: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.amountAUD',
    defaultMessage: 'Amount (AUD)',
  },
  amountUSD: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.amountUSD',
    defaultMessage: 'Amount (NZD)',
  },
  dateOfIncident: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.dateOfIncident',
    defaultMessage: 'Date Of Incident',
  },
  selectInsuredForExpense: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  amountClaimExceedsMaximumDigits: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimExceedsMaximumDigits',
    defaultMessage: 'Amount Claimed exceeds the maximum allowable digits. Please enter a valid claim amount.',
  },
  amountClaimedCannotBeZero: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimedCannotBeZero',
    defaultMessage: 'Amount Claimed cannot be 0.',
  },
  descriptionMaxLength: {
    id: 'fastCover.cashBankCardsTravelDocumentsAndPassportsStep.descriptionMaxLength',
    defaultMessage: 'Please enter maximum of 150 characters',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/messages.js